import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Mobile crane — telescoping boom. Used for Gradall.
export const CRANE_ALT_NODES: IconNode = [
  [
    'path',
    {
      key: 'crane-alt-0',
      d: 'M2.5 18C2.5 18.5304 2.71071 19.0391 3.08579 19.4142C3.46086 19.7893 3.96957 20 4.5 20C5.03043 20 5.53914 19.7893 5.91421 19.4142C6.28929 19.0391 6.5 18.5304 6.5 18C6.5 17.4696 6.28929 16.9609 5.91421 16.5858C5.53914 16.2107 5.03043 16 4.5 16C3.96957 16 3.46086 16.2107 3.08579 16.5858C2.71071 16.9609 2.5 17.4696 2.5 18ZM2.5 18V13H11.5M6.5 19H14.5M18.5 19H20.5V13M20.5 13C20.5 11.6739 19.9732 10.4021 19.0355 9.46447C18.0979 8.52678 16.8261 8 15.5 8H14.5M20.5 13H16L14.5 8M14.5 8H11.5V19M3.5 13V7L21.5 4V6M3.5 7L7.5 9V13M14.5 18C14.5 18.5304 14.7107 19.0391 15.0858 19.4142C15.4609 19.7893 15.9696 20 16.5 20C17.0304 20 17.5391 19.7893 17.9142 19.4142C18.2893 19.0391 18.5 18.5304 18.5 18C18.5 17.4696 18.2893 16.9609 17.9142 16.5858C17.5391 16.2107 17.0304 16 16.5 16C15.9696 16 15.4609 16.2107 15.0858 16.5858C14.7107 16.9609 14.5 17.4696 14.5 18Z',
    },
  ],
]

export const CraneAltIcon: LucideIcon = createLucideIcon(
  'crane-alt',
  CRANE_ALT_NODES,
)
